// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"articles_wrapper__dhWCj","breadcrumbs":"articles_breadcrumbs__XdTAP"};